const state = () => ({
  isValid: false,
  birthYear: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  birthYear(state) {
    return state.birthYear;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateBirthYear(state, payload) {
    state.birthYear = payload;
  },
  resetStore(s) {
    Object.assign(s, state());
  }
};

const actions = {
  updateBirthYear({ commit }, payload) {
    commit('updateBirthYear', payload);
  }
};

export const birthYear = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
